import React, { useEffect, useState } from "react";
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid, Card, CardContent, Typography, makeStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from "lodash";
import LineGraph from '../../../../../src/globalcomponents/patient360/linearWrapper';
import { format, parseISO } from 'date-fns';
import BPicon from '../../../../../src/img/dashboard_icons/BPicon.svg';
import Stepsicon from '../../../../../src/img/dashboard_icons/footstepsicon.svg'
import Stairs from '../../../../../src/img/steps-icon.svg';
import BloodGlucose from '../../../../../src/img/dashboard_icons/Blood-Glucose.svg';
import CaloriesBurnt from '../../../../../src/img/dashboard_icons/CaloriesBurnt.svg'
import OxygenIcon from '../../../../../src/img/oxygen-icon.svg';
import BloodPressure from '../../../../../src/img/Group 14412.svg'
import WeightIcon from '../../../../../src/img/weight-icon.png';
import HeightIcon from '../../../../../src/img/height-icon.svg'
import SleepIcon from '../../../../../src/img/sleep-icon.svg';
import StandIcon from '../../../../../src/img/stand-icon.svg';
import CycleIcon from '../../../../../src/img/cycle-icon.svg';
import ExcerciseIcon from '../../../../../src/img/excercise-icon.svg';
import RestingIcon from '../../../../../src/img/resting-icon.svg';
import SwimmingIcon from '../../../../../src/img/swiming-icon.svg';
import BodyTempIcon from '../../../../../src/img/body-temp-icon.svg';
import HeartIcon from '../../../../../src/img/heart-icon.svg';
import WalkAndRunIcon from '../../../../../src/img/walk-run-icon.svg';
import BodyMassIndexIcon from '../../../../../src/img/body-mass-index.svg';

import moment from 'moment';
import { appConfig } from '../../../../common/constants'



function MetricsGraph(props) {
    let [progress, setProgress] = useState(false);
    const graphData = props.location.state?.filteredData || [];

    const [selectedRange, setSelectedRange] = useState("All");
    const [filteredData, setFilteredData] = useState(() => {
        const groupedByDateType = {};

        graphData.forEach(item => {
            const dateKey = item.endDate.split(" ")[0];
            const key = `${item.type}-${dateKey}`;
            if (!groupedByDateType[key] || new Date(item.endDate) > new Date(groupedByDateType[key].endDate)) {
                groupedByDateType[key] = item;
            }
        });

        return Object.values(groupedByDateType).sort((a, b) => new Date(a.endDate) - new Date(b.endDate));
    });


    const typeLabelMap = {
        BloodPressureCombined: "Blood Pressure",
        BloodPressureCount: "Blood Pressure",
        BloodGulcoseCount: "Blood Glucose",
        HeartCount: "Heart rate",
        SleepCount: "Sleep",
        Weight: "Weight",
        Height: "Height",
        PeakFlow: "Peak flow",
        Bodytemperature: "Temperature",
        StepsCount: "Steps",
        OxegenCount: "Blood oxygen",
        ExerciseMinutes: "Exercise minutes",
        RunningWalking: "Distance (walking+Running)",
        CaloriesCount: "Calories burnt",
        RestingHR: "Resting HR",
        BreathingRate: "Breathing rate /Respiratory rate",
        BodyMass: "Body mass index",
        Floors: "Stairs climbed",
        CyclingDistance: "Cycling Distance",
        SwimmingDistance: "Swimming Distance",
        StandHours: "Stand Hours",
        ExerciseDistance: "Exercise Distance",
        ExerciseDistance: "Exercise Distance",
        BodyMassIndex: 'Body Mass Index'
    };
    const typeIconMap = {
        BloodPressureCombined: BloodPressure,
        BloodPressureCount: BloodPressure,
        BloodGulcoseCount: BloodGlucose,
        HeartCount: HeartIcon,
        SleepCount: SleepIcon,
        Weight: WeightIcon,
        Height: HeightIcon,
        Bodytemperature: BodyTempIcon,
        StepsCount: Stepsicon,
        OxegenCount: OxygenIcon,
        ExerciseMinutes: ExcerciseIcon,
        RunningWalking: WalkAndRunIcon,
        CaloriesCount: CaloriesBurnt,
        RestingHR: RestingIcon,
        BreathingRate: RestingIcon,
        BodyMass: WeightIcon,
        Floors: Stairs,
        CyclingDistance: CycleIcon,
        SwimmingDistance: SwimmingIcon,
        StandHours: StandIcon,
        ExerciseDistance: ExcerciseIcon,
        BodyMassIndex: BodyMassIndexIcon,
        PeakFlow: StandIcon,
    };
    const goBack = (event) => {
        event.preventDefault();
        props.history.goBack()
    }
  
    const handleFilter = (range) => {
        const now = moment();

        const filtered = graphData.filter(item => {
            const endDate = moment(item.endDate);
            switch (range) {
                case '1w': return endDate.isAfter(now.clone().subtract(1, 'weeks'));
                case '2w': return endDate.isAfter(now.clone().subtract(2, 'weeks'));
                case '1m': return endDate.isAfter(now.clone().subtract(1, 'months'));
                case '3m': return endDate.isAfter(now.clone().subtract(3, 'months'));
                case '6m': return endDate.isAfter(now.clone().subtract(6, 'months'));
                case '1y': return endDate.isAfter(now.clone().subtract(1, 'years'));
                case 'All':
                default: return true;
            }
        });

        const groupedByDateType = {};

        filtered.forEach(item => {
            const dateKey = item.endDate.split(" ")[0];
            const key = `${item.type}-${dateKey}`;
            if (!groupedByDateType[key] || new Date(item.endDate) > new Date(groupedByDateType[key].endDate)) {
                groupedByDateType[key] = item;
            }
        });

        setFilteredData(Object.values(groupedByDateType).sort((a, b) => new Date(a.endDate) - new Date(b.endDate)));
    };

    const sys = filteredData
        .filter(item => item.type === "BloodPressureSysCount")
        .map(item => item.value);
    console.log(sys, "sys")
    const dia = filteredData
        .filter(item => item.type === "BloodPressureDiaCount")
        .map(item => item.value);
    const getAvailableRanges = () => {
        const now = moment();
        const available = [];

        const ranges = {
            '1w': now.clone().subtract(1, 'weeks'),
            '2w': now.clone().subtract(2, 'weeks'),
            '1m': now.clone().subtract(1, 'months'),
            '3m': now.clone().subtract(3, 'months'),
            '6m': now.clone().subtract(6, 'months'),
            '1y': now.clone().subtract(1, 'years'),
            'All': moment('1900-01-01')
        };

        for (const [key, date] of Object.entries(ranges)) {
            const hasData = graphData.some(item => moment(item.endDate).isAfter(date));
            if (hasData || key === 'All') {
                available.push(key);
            }
        }

        return available;
    };
    const availableRanges = getAvailableRanges();

    useEffect(() => {
        if (!availableRanges.includes(selectedRange)) {
            setSelectedRange('All');
            handleFilter('All');
        }
    }, [availableRanges.join(','), selectedRange]);




    return (
        <>
            {progress && <div className="fullScreen">
                <CircularProgress
                    disableShrink
                    className="progressCircle"
                    value={90}
                    size={100}
                    thickness={1.5}
                />
            </div>}
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '10px', marginBottom: '30px', marginTop: '30px' }}>
                <h1 className="mr-auto primary-header">{sys.length > 0 && dia.length > 0 ? 'Blood Pressure' : typeLabelMap[graphData[0]?.type]}</h1>
                <button className="btn btn-primary-blue btn-rounded btn-small" style={{ float: "right" }} onClick={goBack}>
                    Back
                </button>
            </div>

            <div style={{ display: 'flex', justifyContent: 'left', marginTop: '30px', marginBottom: '30px' }}>
                <select
                    value={selectedRange}
                    onChange={(e) => {
                        const range = e.target.value;
                        setSelectedRange(range);
                        handleFilter(range);
                    }}
                    style={{
                        padding: '4px',
                        borderRadius: '5px',
                        border: 'none',
                        border: '1px solid black',
                        fontSize: '16px',
                    }}
                >
                    {availableRanges.includes("1w") && <option value="1w"> 1 Week</option>}
                    {availableRanges.includes("2w") && <option value="2w"> 2 Weeks</option>}
                    {availableRanges.includes("1m") && <option value="1m"> 1 Month</option>}
                    {availableRanges.includes("3m") && <option value="3m"> 3 Months</option>}
                    {availableRanges.includes("6m") && <option value="6m"> 6 Months</option>}
                    {availableRanges.includes("1y") && <option value="1y"> 1 Year</option>}
                    <option value="All">All</option>
                </select>
            </div>




            <LineGraph
                data={sys.length > 0 && dia.length > 0 ? sys : filteredData.map(item => item.value)}
                data1={dia}
                xaxisdata={[...new Set(filteredData.map(item => moment(item.endDate).format('DD/MM/YYYY')))]}
                name={sys.length > 0 && dia.length > 0 ? 'Blood Pressure' : typeLabelMap[filteredData[0]?.type]}
                unit={filteredData[0]?.unit ?? ''}
            />

        </>
    )

}
const mapStateToProps = (state) => {
    return {
        formValues: state.form,
        langData: state.langData,
        lang: state.lang,
        state
    }
}

export default withRouter(connect(mapStateToProps, null)(MetricsGraph));






